import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/reduxHooks';
import utils from '../../utils';

export const ShouldShowHeader = ({ setShouldShowHeader }) => {
  const { loginData, isLogged } = useAppSelector(({ adminReducer }) => adminReducer);
  const location = useLocation();

  useEffect(() => {
    const { user } = loginData;
    const hasToken = !!user?.token;

    if (!hasToken) {
      setShouldShowHeader(false);
      return;
    }

    // Obtener roles del usuario - intentar desde userData primero, luego del token
    let roles = user?.userData?.roles || [];

    // Si no hay roles en userData, intentar obtenerlos del token
    if (roles.length === 0 && user?.token) {
      try {
        const tokenRoles = utils.getRoles();
        roles = tokenRoles || [];
      } catch (error) {
        // Si falla, mantener array vacío
        roles = [];
      }
    }

    // Normalizar roles a mayúsculas para comparación
    const normalizedRoles = roles.map((role) => String(role).toUpperCase().trim());

    // Debug temporal: mostrar roles en un alert (solo para desarrollo)
    if (roles.length > 0 && process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-alert
      window.showRolesDebug = () => {
        // eslint-disable-next-line no-alert
        alert(`Roles encontrados:\n${JSON.stringify(roles, null, 2)}\n\nRoles normalizados:\n${JSON.stringify(normalizedRoles, null, 2)}`);
      };
    }

    // Verificar si tiene el rol CONFIG (no debe ver el header) - case insensitive
    const hasConfigRole = normalizedRoles.some(
      (role) => role === 'CONFIG' || role.includes('CONFIG')
    );

    // Verificar si tiene ADMIN o ADMIN_DENUNCIAS - case insensitive
    const hasAdminRole = normalizedRoles.some(
      (role) =>
        role === 'ADMIN' ||
        role === 'ADMIN_DENUNCIAS' ||
        role.includes('ADMIN') ||
        role.includes('ADMIN_DENUNCIAS')
    );

    // Mostrar header solo si tiene ADMIN o ADMIN_DENUNCIAS Y NO tiene CONFIG
    setShouldShowHeader(hasAdminRole && !hasConfigRole);
  }, [location, isLogged, loginData.user]);

  return <></>;
};
